import axiosInstance from '../utility/axios';

export const showError = (errorMessage) => ({
  type: 'SHOW_ERROR',
  errorMessage
});

export const startSendMicrositeEmail = () => ({
  type: 'START_SEND_MICROSITE_EMAIL'
});

export const sendMicrositeEmailSuccess = (company) => ({
  type: 'SEND_MICROSITE_EMAIL_SUCCESS',
  company
});

export const sendMicrositeEmail = (company) => {
  console.log('sending microsite email', company);
  return (dispatch) => {
    dispatch(startSendMicrositeEmail());
    axiosInstance.get(`microsite-submission?company=${company}`, company)
      .then((response) => {
        dispatch(sendMicrositeEmailSuccess(response.data));
        console.log('microsite email submission sent');
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

export const startSendStatEmail = () => ({
  type: 'START_SEND_STAT_EMAIL'
});

export const sendStatEmailSuccess = (statInfo) => ({
  type: 'SEND_STAT_EMAIL_SUCCESS',
  statInfo
});

export const sendStatEmail = (statInfo) => {
  console.log('sending stat notification email', statInfo);
  return (dispatch) => {
    dispatch(startSendStatEmail());
    axiosInstance.post(`stat-notification`, statInfo)
      .then((response) => {
        dispatch(sendStatEmailSuccess(response.data));
        console.log('stat notification email submission sent');
      })
      .catch((error) => {
        dispatch(showError(error));
        console.log(error);
      });
  }
};

